export const buildFilterForSingleReport = (id: number) => {
  const queryParams = new URLSearchParams();
  const filter = `{"name":"id","type":"number","operator":"eq","value":"${id}"}`;
  queryParams.set("filters", filter);
  return queryParams.toString();
};
